// filterOptions — the static lookup tables backing the RestaurantSearch filters.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (the module-level
// `cuisineOptions`, `priceOptions`, `ratingOptions`, and `radiusOptions`
// arrays) as part of the behavior-preserving refactor (issue #240). Every
// `{ value, label }` entry, its order, and its exact string values are copied
// unchanged.
//
// PRESERVED QUIRKS (do NOT "fix"):
//   `priceOptions` intentionally contains duplicate `value` fields — `'$'`
//   appears for both "Budget" and "Moderate", and `'$$'` appears for both
//   "Expensive" and "Very Expensive". This is a quirk of the source. "Fixing"
//   the values (e.g. to `'$$$'`/`'$$$$'`) would change the option values the
//   `<select>` emits and thus the search params, which would alter behavior.
//   The duplicates are therefore preserved EXACTLY as in the source.
//
// React-free and side-effect-free (module-level static data).
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Cuisine filter options.
 * @type {Array<{ value: string, label: string }>}
 */
export const cuisineOptions = [
  { value: '', label: 'Any' },
  { value: 'American', label: 'American' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Mexican', label: 'Mexican' },
  { value: 'Steakhouse', label: 'Steakhouse' },
  { value: 'Seafood', label: 'Seafood' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'French', label: 'French' },
  { value: 'Chinese', label: 'Chinese' }
];

/**
 * Price-range filter options.
 *
 * NOTE: the duplicate `'$'` and `'$$'` values are intentional and copied
 * verbatim from the source — see the PRESERVED QUIRKS note above.
 * @type {Array<{ value: string, label: string }>}
 */
export const priceOptions = [
  { value: '', label: 'Any' },
  { value: '$', label: '$ - Budget' },
  { value: '$', label: '$ - Moderate' },
  { value: '$$', label: '$$ - Expensive' },
  { value: '$$', label: '$$ - Very Expensive' }
];

/**
 * Minimum-rating filter options.
 * @type {Array<{ value: string, label: string }>}
 */
export const ratingOptions = [
  { value: '0', label: 'Any' },
  { value: '3.5', label: '3.5+' },
  { value: '4.0', label: '4.0+' },
  { value: '4.5', label: '4.5+' }
];

/**
 * Search-radius filter options.
 * @type {Array<{ value: string, label: string }>}
 */
export const radiusOptions = [
  { value: '1', label: '1 mile' },
  { value: '2', label: '2 miles' },
  { value: '5', label: '5 miles' },
  { value: '10', label: '10 miles' },
  { value: '25', label: '25 miles' }
];

export default { cuisineOptions, priceOptions, ratingOptions, radiusOptions };
